import { canvas } from '@carvana/ds-styles';
import styled from 'styled-components';

export const Container = styled.div<{ $nativeMobile?: boolean }>`
  background-color: #e4ecf0;
  width: 100%;

  ${({ $nativeMobile }) =>
    $nativeMobile &&
    `
    height: max-content;
  `}
`;

export const Inner = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1800px;
  background-color: ${canvas.default};
`;
